import { httpClient, httpQueryCarlorie } from '@/api/index'
export const _uploadExcel = (url, canteen_id) => {
  return httpClient
    .post(
      `load/excel/`,
      {
        url
      },
      {
        headers: {
          'canteen-id': canteen_id
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`))
      }
    })
}
export const _uploadExcelNutrition = (url, canteen_id) => {
  return httpClient
    .post(
      `load/nutrition_excel/`,
      {
        url
      },
      {
        headers: {
          'canteen-id': canteen_id
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`))
      }
    })
}
export const _setPermanent = ({ canteen_id, food_uuid, food_permanent }) => {
  return httpClient
    .post(
      `menu/set_permanent/`,
      { canteen_id, food_uuid, food_permanent },
      {
        headers: {
          canteen_id
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`))
      }
    })
}
export const _getMenuByDate = (filter_form, canteen_id) => {
  return httpClient
    .post(`v0.1/menu/getbydate/`, filter_form, {
      headers: {
        'canteen-id': canteen_id
      }
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.msg}`))
      }
    })
}
export const _deleteMenus = (filter_form, canteen_id) => {
  return httpClient
    .post(`menu/batch_delete/`, filter_form, {
      headers: {
        'canteen-id': canteen_id
      }
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`))
      }
    })
}
export const _queryCalorieByFoodName = food_name => {
  return httpQueryCarlorie.get(`food/search?q=${food_name}/`).then(res => {
    console.log('sadasdsadasdas', res)
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _queryCalorieByFoodNameCalorieMode = filter_form => {
  return httpClient.post(`calorie_query`, filter_form).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _menuBatchAdd = (data, canteen_id) => {
  return httpClient
    .post(
      `menu/batch_add/`,
      { data },
      {
        headers: {
          'canteen-id': canteen_id
        }
      }
    )
    .then(res => {
      return Promise.resolve(res.data)
    })
}
export const _menuBatchUpdate = (foods, canteen_id) => {
  return httpClient.post(`menu/batch_update/`,
    { data: foods }, {
      headers: {
        'canteen-id': canteen_id
      } }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _menuAdd = (menu, canteen_id) => {
  return httpClient.post(`menu/add/`,
    menu, {
      headers: {
        'canteen-id': canteen_id
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
export const _menuDelete = (filter_form, canteen_id) => {
  console.log(filter_form)
  return httpClient.post(`menu/delete/`,
    filter_form, {
      headers: {
        'canteen-id': canteen_id
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _menuImgQueryByfoodUuidList = (food_uuid_list) => {
  return httpClient.post(`menu/img_query/by_food_uuid_list`,
    { food_uuid_list }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _foodQueryByName = (food_name) => {
  return httpClient.post(`food_query_by_name`,
    { food_name }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _menuUpdate = (food, canteen_id) => {
  return httpClient.post(`menu/update/`,
    food, {
      headers: {
        'canteen-id': canteen_id
      } }).then(res => {
    console.log(res.data.error_msg)
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
